import * as d3 from "d3";
import { format } from "date-fns";
import { isPowerOfTen } from "./scalesUtils";
function createAxes(xScale, yScale, beginning, now, xTicks, yTicks, xMajorTickInterval, yMajorTickInterval, timeWindow, yUnits, yMin, yMax, logarithmic = false, xFormat) {
    let xTickValues = [];
    let xMajorTickValues = [];
    // Only calculate x tick values if xTicks is provided and greater than 1
    if (xTicks && xTicks > 1) {
        const minorTickInterval = timeWindow * 60 * 1000 / (xTicks - 1);
        for(let time = beginning.getTime(); time <= now.getTime(); time += minorTickInterval){
            xTickValues.push(new Date(time));
        }
        // Select major tick values based on xMajorTickInterval
        xMajorTickValues = xTickValues.filter((_, i)=>i % xMajorTickInterval === 0);
    }
    let yTickValues = [];
    let yMajorTickValues = [];
    // Only calculate y tick values if yTicks is provided and greater than 1
    if (yTicks && yTicks > 1) {
        if (logarithmic) {
            yTickValues = yScale.ticks(yTicks).filter((val, _)=>isPowerOfTen(val));
            yMajorTickValues = yTickValues.filter((_, i)=>i % yMajorTickInterval === 0);
        } else {
            yTickValues = Array.from({
                length: yTicks
            }, (_, i)=>parseFloat((yMin + (yMax - yMin) / (yTicks - 1) * i).toFixed(2)));
            yMajorTickValues = yTickValues.filter((_, i)=>i % yMajorTickInterval === 0);
        }
    }
    // Define axes
    const xAxis = d3.axisBottom(xScale).tickValues(xMajorTickValues) // If empty, no ticks will be rendered
    .tickFormat((domainValue, _)=>{
        const date = domainValue instanceof Date ? domainValue : new Date(domainValue.valueOf());
        /* Future note: I think sending in the xFormat will be easier than adding window adjustments like below */ if (xFormat) {
            return format(date, xFormat ?? "HH:mm");
        }
        let formattedTime = "";
        // Add date if time window is longer than 24hr
        if (timeWindow > 1440) {
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            formattedTime += `${month}/${day}, `;
        }
        // Format as "HH:MM"
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        formattedTime += `${hours}:${minutes}`;
        return formattedTime;
    }).tickSize(0).tickPadding(15);
    const yAxis = d3.axisLeft(yScale).tickValues(yMajorTickValues) // If empty, no ticks will be rendered
    .tickFormat((d)=>{
        if (!yUnits) {
            return `${d3.format("~s")(d)}`;
        } else {
            return `${d}${yUnits}`;
        }
    }).tickSize(0).tickPadding(10);
    return {
        xAxis,
        yAxis,
        xTickValues,
        xMajorTickValues,
        yTickValues,
        yMajorTickValues
    };
}
function drawAxes(chart, xAxis, yAxis, innerHeight) {
    // Append x-axis
    chart.append("g").attr("class", "x-axis").attr("transform", `translate(0, ${innerHeight})`).call(xAxis).selectAll("text").attr("fill", "#68677C").attr("font-family", "Aeonik Light").attr("class", "font-aeonik text-gray-500 text-xs");
    // Customize x-axis line
    chart.select(".x-axis").select(".domain").attr("stroke", "#8F8E9C").attr("stroke-width", 0.7).attr("stroke-dasharray", "0");
    // Append y-axis
    chart.append("g").attr("class", "y-axis").call(yAxis).selectAll("text").attr("fill", "#68677C").attr("font-family", "Aeonik Light").attr("class", "font-aeonik text-gray-500 text-xs");
    // Customize y-axis line
    chart.select(".y-axis").select(".domain").attr("stroke", "#8F8E9C").attr("stroke-width", 0.7).attr("stroke-dasharray", "0");
}
export { createAxes, drawAxes };
